import { axiosInstance } from "./BaseService" 

export async function fetchForecastsData() {
  try {
    const response = await axiosInstance.get("/forecasts");
    return response.data;
  } catch (err) {
    throw err;
  }
}